import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Input, Button, DatePicker } from 'antd';
import swal from 'sweetalert';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { getCompaniesData } from '../../actions/index';
import './ManageAnalytics.css';
import Translation from '../../Translation';
import moment from 'moment';

/**
 * Class for ManageSignIns.
 *
 * @class ManageSignIns
 * @extends {React.Component}
 */
class ManageAnalytics extends React.Component {
    constructor(props) {
        super(props);
        let today = new Date();
        let fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 1);
        this.state = {
            loading: false,
            isModalVisible: false,
            isLongMessageModalVisible: false,
            rows: [],
            apiData: [],
            messagesList: [],
            longMessageText: '',
            userRole: 'user',
            userCompany: '',
            username: null,
            isAdd: true,
            emailAddress: '',
            firstName: '',
            lastName: '',
            password: '',
            cpassword: '',
            userCountry: '',
            errorMessage: null,
            isCreateLoading: false,

            sortedInfo: {
                columnKey: 'logTime',
                order: 'descend'
            },
            filteredInfo: {},
            isDuplicateInTowplus: false,
            countryNames: [],

            startDate: moment(fromDate),
            endDate: moment(today),

            transactionList: [],
            transactionHash: {}
        }
        
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys ? opts.selectedKeys[0] : '' }
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
     handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getMessagesList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageUsers
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageUsers
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageUsers
     */
    getMessagesList = () => {
        this.setState({
            loading: true
        });
        CelaneseAPI.post(config.API.getAnalytics, {
            fromDate: this.state.startDate,
            toDate: this.state.endDate
        }).then(resp => {
            let logList = resp && resp.data ? resp.data : [];
            let transactionHash = {};
            let transactionList = [];
            for (let i = 0 ; i < logList.length; i++) {
                let logItem = logList[i];
                if (logItem.logTransactionId && logItem.logTransactionId.length > 0) {
                    if (!transactionHash['T' + logItem.logTransactionId]) {
                        transactionList.push({
                            logTransactionId: logItem.logTransactionId
                        });
                        transactionHash['T' + logItem.logTransactionId] = {};
                    }
                    transactionHash['T' + logItem.logTransactionId][logItem.eventPage] = logItem;
                    if (logItem.eventPage === 'LOGIN') {
                        let transactionItem = transactionList.find(item => item.logTransactionId === logItem.logTransactionId);
                        transactionItem['logTime'] = logItem.logTime;
                        transactionItem['createdAt'] = logItem.createdAt;
                        if (logItem.logInfo && logItem.logInfo.localTime) {
                            transactionItem['localTime'] = logItem.logInfo.localTime;
                        }
                    }
                }
            }
            transactionList.sort((b, a) => {
                if ((a.createdAt - 0) < (b.createdAt - 0)) { return -1; }
                if ((a.createdAt - 0) > (b.createdAt - 0)) { return 1; }
                return 0;
            });
            this.setState({
                messagesList: transactionList,
                loading: false,
                rows: transactionList,
                transactionHash: transactionHash
            });
        });
    }

    onCreateMessageSuccess = () => {
        this.setState({
            isModalVisible: false
        });
        this.getMessagesList();
    }

    sendEmailInvitation = (formData) => {
        if (formData['role'] && formData['role'].toUpperCase() === 'user'.toUpperCase()) {
            CelaneseAPI.post(config.API.sendInvitation, {
                "to": formData['emailAddress'],
                "firstname": formData['firstName'],
                "lastname": formData['lastName'],
                "loginUrl": window.location.origin,
                "password": formData['password']
            });
        }
    }
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_user_items','Fetching sign-in items'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds','Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting towitems in excel format
         */
        CelaneseAPI.getBlob('/export-sign-ins?format=excel&fromDate=' + this.state.startDate + '&toDate=' + this.state.endDate).then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-users-link');
            if(document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'sign-in-report-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'sign-in-report-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }
    exportFile(e) {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database','Database has zero sign-in items, Do you want to continue to export with empty sign-in items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }
    }

    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    clearFilters = (e) => {
        e.preventDefault();
        let today = new Date();
        let fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 1);
        this.setState({
            sortedInfo: {
                columnKey: 'lastLogin',
                order: 'descend'
            },
            filteredInfo: {},
            startDate: moment(fromDate),
            endDate: moment(today)
        });
    }

    onTableChange = (a, b, c) => {
        this.setState({
            sortedInfo: c,
            filteredInfo: b
        });
    }
    handleDateChange = (e, dateType) => {
        this.setState({
            [dateType]: e
        });
        this.getMessagesList();
    }

    sendInvitationToUser = (e) => {
        e.preventDefault();
        this.setState({
            loading: true
        });
        CelaneseAPI.post(config.API.sendInvitation, {
            "to": this.state.emailAddress,
            "firstname": this.state.firstName,
            "lastname": this.state.lastName,
            "loginUrl": window.location.origin
        }).then(resp => {
            this.setState({
                loading: false,
                visibleCompany: false
            });
        });
    }
    disabledDate = (current) => {
        return current && current > moment().endOf('day');
    }
    disabledFromDate = (current) => {
        // Can not select days before today and today
        return current && current > this.state.endDate;
    }
    render() {
        let { transactionHash } = this.state;
        // console.log("filter infor: ", Object.keys(filteredInfo).filter(x => filteredInfo[x]).length);
        this.columns = [{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Login Session"/>,
            key: 'logTransactionId',
            align: 'left',
            render: (rec) => {
                let displayItem = rec.logTransactionId;
                return (<span>{displayItem}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="TowPlus® Login"/>,
            key: 'login',
            align: 'left',
            render: (rec) => {
                let displayText = 'Missed';
                if (transactionHash['T' + rec.logTransactionId]) {
                    let pageLog = transactionHash['T' + rec.logTransactionId]['LOGIN']
                    if (pageLog) {
                        let logTime = pageLog['logTime'];
                        if (logTime) {
                            let timestampDisplay = new Date(logTime - 0);
                            let mm = timestampDisplay.getMonth();
                            mm += 1;
                            mm = (mm < 10 ? '0' : '') + mm;
                            let dd = timestampDisplay.getDate();
                            let yyyy = timestampDisplay.getFullYear();

                            var hours = timestampDisplay.getHours();
                            var minutes = timestampDisplay.getMinutes();
                            let ss = timestampDisplay.getSeconds();
                            var ampm = hours >= 12 ? 'PM' : 'AM';
                            hours %= 12;
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            hours = (hours < 10 ? '0' : '') + hours;
                            ss = (ss < 10 ? '0' : '') + ss;

                            displayText = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${ss} ${ampm}`;
                        }
                    }
                }
                return (<span>{displayText}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Azure Login"/>,
            key: 'azurelogin',
            align: 'left',
            render: (rec) => {
                let displayText = 'Missed';
                if (transactionHash['T' + rec.logTransactionId]) {
                    let pageLog = transactionHash['T' + rec.logTransactionId]['AZURE_LOGIN']
                    if (pageLog) {
                        let logTime = pageLog['logTime'];
                        if (logTime) {
                            let timestampDisplay = new Date(logTime - 0);
                            let mm = timestampDisplay.getMonth();
                            mm +=  1;
                            mm = (mm < 10 ? '0' : '') + mm;
                            let dd = timestampDisplay.getDate();
                            let yyyy = timestampDisplay.getFullYear();

                            var hours = timestampDisplay.getHours();
                            var minutes = timestampDisplay.getMinutes();
                            let ss = timestampDisplay.getSeconds();
                            var ampm = hours >= 12 ? 'PM' : 'AM';
                            hours %= 12;
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            hours = (hours < 10 ? '0' : '') + hours;
                            ss = (ss < 10 ? '0' : '') + ss;

                            displayText = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${ss} ${ampm}`;
                        }
                    }
                }
                return (<span>{displayText}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="TowPlus® Landing Page"/>,
            key: 'landing',
            align: 'left',
            render: (rec) => {
                let displayText = 'Missed';
                if (transactionHash['T' + rec.logTransactionId]) {
                    let pageLog = transactionHash['T' + rec.logTransactionId]['LANDING']
                    if (pageLog) {
                        let logTime = pageLog['logTime'];
                        if (logTime) {
                            let timestampDisplay = new Date(logTime - 0);
                            let mm = timestampDisplay.getMonth();
                            mm += 1;
                            mm = (mm < 10 ? '0' : '') + mm;
                            let dd = timestampDisplay.getDate();
                            let yyyy = timestampDisplay.getFullYear();

                            var hours = timestampDisplay.getHours();
                            var minutes = timestampDisplay.getMinutes();
                            let ss = timestampDisplay.getSeconds();
                            var ampm = hours >= 12 ? 'PM' : 'AM';
                            hours %= 12;
                            hours = hours ? hours : 12;
                            minutes = minutes < 10 ? '0' + minutes : minutes;
                            hours = (hours < 10 ? '0' : '') + hours;
                            ss = (ss < 10 ? '0' : '') + ss;

                            displayText = `${mm}/${dd}/${yyyy} ${hours}:${minutes}:${ss} ${ampm}`;

                            if (pageLog.logInfo) {
                                if (pageLog.logInfo.username) {
                                    displayText = pageLog.logInfo.username;
                                }
                                if (pageLog.logInfo.error) {
                                    let href = pageLog.logInfo.error.href;
                                    displayText = 'Error during login';
                                    if (href) {
                                        let seperator = href.indexOf('?') >= 0 ? '?' : '#';
                                        let paramString = href.split(seperator);
                                        if (paramString && paramString.length > 1) {
                                            let qParams = paramString[1].split('&');
                                            if (qParams && qParams.length > 0) {
                                                let qParam = qParams.find(item => item.indexOf('error_description') >= 0);
                                                if (qParam) {
                                                    let nameVal = qParam.split('=');
                                                    if (nameVal && nameVal.length > 1) {
                                                        if (nameVal[1].indexOf('AADB2C90091') >= 0) {
                                                            displayText = 'The user has cancelled entering self-asserted information';
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                        }
                    }
                }
                return (<span>{displayText}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Country (Timezone)"/>,
            key: 'country',
            align: 'left',
            render: (rec) => {
                let displayText = '';
                if (rec['localTime']) {
                    let localTime = rec.localTime;
                    if (localTime.indexOf('(') >= 0 && localTime.indexOf(')') >= 0) {
                        localTime = localTime.split('(')[1];
                        displayText = localTime.split(')')[0];
                    } else {
                        displayText = localTime;
                    }
                }
                return (<span>{displayText}</span>);
            }
        }];
       
        return (
            <Fragment>
                <div className="cmp-manage-messages__header">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_sign_in" defaultText="Detailed Sign-in"/>} />
                    <div className="cmp-manage-messages__header-links">
                        <div className="cmp-manage-messages__header-links-wrapper">
                            {
                                this.state.rows.length ? (
                                    <h4 className="users-length-label"><Translation labelName="lbl_available_user_items" defaultText="Login items" />: <strong>{this.state.rows.length}</strong></h4>
                                ) : ''
                            }
                            {/* <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button> */}
                        </div>
                        
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <div className="m1-bottom">
                            <div className="flex align-center">
                                <div className="flex-1 ">
                                    <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.clearFilters(e)}><Translation labelName="btn_clear_filters" defaultText="Clear Filters" /></button>
                                    <button type="button" className="btn btn-default m1-left" onClick={(e) => { this.clearFilters(e);this.getMessagesList(e); }}><Translation labelName="btn_clear_filters_and_reload" defaultText="Refresh Table" /></button>
                                </div>
                                <div className="flex-1 flex flex-end">
                                    <div className=''>
                                        <label><Translation labelName="lbl_country_start_date" defaultText="Start date" /> (MM/DD/YYYY)</label>
                                        <DatePicker disabledDate={this.disabledFromDate} value={this.state.startDate} format="MM/DD/YYYY" onChange={(e) => { this.handleDateChange(e, 'startDate')  }}/>
                                    </div>
                                    <div className='m2-left'>
                                        <label><Translation labelName="lbl_country_end_date" defaultText="End date" /> (MM/DD/YYYY)</label>
                                        <DatePicker disabledDate={this.disabledDate} value={this.state.endDate} format="MM/DD/YYYY" onChange={(e) => { this.handleDateChange(e, 'endDate')  }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table
                            dataSource={this.state.rows}
                            columns={this.columns}
                            rowKey={Math.random}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            onChange={this.onTableChange}
                            scroll={{ y: 'calc(100vh - 230px)' }}
                            size="middle" />
                    </div>
                </div>
                <a href="" className="export-users-hidden" id="export-users-link" download=""></a>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageAnalytics);

ManageAnalytics.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/ManageAnalytics/index.js